import { Stack } from "@mui/material";
import { ButtonLink } from "Components/Shared/ButtonLink";
import { useNewPaymentPageLink } from "Hooks/useNewPaymentPageLink";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Merchant.InitiateDetail;

export const SuccessfulPaymentActions = () => {
  const { t } = useResource();
  const newPaymentPageLink = useNewPaymentPageLink();

  return (
    <Stack gap={2} width="100%" px={[0, 15]}>
      {newPaymentPageLink && (
        <ButtonLink
          resetHistory
          color="primary"
          variant="contained"
          link={newPaymentPageLink}
          text={t(RESOURCES.CreateAnotherPayment)}
        />
      )}
      <ButtonLink
        resetHistory
        color="primary"
        variant="text"
        link={appUrl("dashboard")}
        text={t(RESOURCES.BackToOverview)}
        sx={{
          fontWeight: 400,
          height: "auto",
          textTransform: "none",
        }}
      />
    </Stack>
  );
};
